import { toastr } from "react-redux-toastr";
class NotifierServiceImpl {
  static instance = null;

  static getInstance() {
    if (!NotifierServiceImpl.instance) {
      NotifierServiceImpl.instance = new NotifierServiceImpl();
    }
    return NotifierServiceImpl.instance;
  }

  show(message) {
    if (message.type === "E") {
      this.error(message.message);
    } else if (message.type === "W") {
      this.warn(message.message);
    } else if (message.type === "S") {
      this.success(message.message);
    } else {
      this.info(message.message);
    }
  }

  success(message) {
    toastr.success(message);
  }

  error(message) {
    toastr.error(message);
  }

  warn(message) {
    toastr.warning(message);
  }

  info(message) {
    toastr.info(message);
  }
}

export const NotifierService = NotifierServiceImpl.getInstance();
